import script from "./form-table-config.vue?vue&type=script&setup=true&lang=js"
export * from "./form-table-config.vue?vue&type=script&setup=true&lang=js"

import "./form-table-config.vue?vue&type=style&index=0&id=642686f4&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642686f4"]])

export default __exports__